import React from "react";
var __jsx = React.createElement;
import stl from "./Suggestions.module.css";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { useLocation } from "react-router-dom";
import { serverUrl } from "@globalConfig";
var Suggestions = function Suggestions(_ref) {
  var suggestionsData = _ref.suggestionsData,
    searchTerm = _ref.searchTerm,
    handleTextSearch = _ref.handleTextSearch;
  var location = useLocation();
  var suggestions = suggestionsData.filter(function (product) {
    return product.autosuggest;
  });
  var renderer = function renderer(suggestion) {
    if (suggestion !== null && suggestion !== void 0 && suggestion.toLowerCase().includes(searchTerm.toLowerCase())) {
      var regex = new RegExp("(".concat(searchTerm, ")"), "gi");
      var parts = suggestion.split(regex);
      return /*#__PURE__*/React.createElement("div", null, parts.map(function (part, index) {
        return regex.test(part) ? /*#__PURE__*/React.createElement("span", {
          key: index,
          className: stl.highlighted
        }, part) : /*#__PURE__*/React.createElement("span", {
          key: index
        }, part);
      }));
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, suggestion));
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: stl.SuggestionsWrapper
  }, suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(function (suggestion) {
    return /*#__PURE__*/React.createElement("li", {
      onClick: function onClick(e) {
        handleTextSearch(e, suggestion.autosuggest);
        unbxdAnalytics({
          action: "search",
          autosuggest_type: "KEYWORD_SUGGESTION",
          autosuggest_suggestion: suggestion.autosuggest,
          field_name: null,
          field_value: null,
          internal_query: searchTerm,
          query: suggestion.autosuggest || "",
          url: serverUrl + location.pathname + location.search
        });
      },
      key: suggestion.autosuggest
    }, renderer(suggestion.autosuggest));
  }));
};
export default Suggestions;